import { MediaroomSettings } from './MediaroomSettings';
import { MediaFirstSettings } from './MediaFirstSettings';
import { Section, SectionContent } from '../../../../components/Section';
import { AccountSettings } from './AccountSettings';
import { SettingSectionHeader } from '../SettingSectionHeader';
import React from 'react';
import { Tune } from '@material-ui/icons';

export const SuggestedSettings = () => (
  <>
    <SettingSectionHeader
      header="Recommended Configurations"
      description="The settings below are optional and can be modified after operator creation but suggested to have configured ahead of time"
      icon={<Tune />}
    />
    <Section>
      <SectionContent spacing={2}>
        <AccountSettings />
        <MediaroomSettings />
        <MediaFirstSettings />
      </SectionContent>
    </Section>
  </>
);
